import React from 'react';

function ConfirmModal({ show, action, onClose, onConfirm }) {
    const actionMessages = {
        delete: {
            title: 'CONFIRMA EXCLUSÃO',
            body: 'Tem certeza que deseja excluir este registro?',
            confirmText: 'Excluir',
            confirmClass: 'btn-danger',
            titleClass: 'text-white', // Classe para o título (vermelho)
            headerClass: 'bg-danger',
        },
        save: {
            title: 'CONFIRMA SALVAMENTO',
            body: 'Deseja salvar as mudanças?',
            confirmText: 'Salvar',
            confirmClass: 'btn-success',
            titleClass: 'text-white', // Classe para o título (verde)
            headerClass: 'bg-success',
        },
        continue: {
            title: 'CONFIRMA CONTINUAÇÃO',
            body: 'Deseja continuar para a próxima página?',
            confirmText: 'Continuar',
            confirmClass: 'btn-primary',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-primary',
        },
        sendAprovacao: {
            title: 'CONFIRMA ENVIO',
            body: 'Deseja enviar o DFD para Aprovação?',
            confirmText: 'Enviar',
            confirmClass: 'btn-success',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-success',
        },
        aprova: {
            title: 'CONFIRMA APROVAÇÃO',
            body: 'Deseja aprovar o DFD?',
            confirmText: 'Aprovar',
            confirmClass: 'btn-success',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-success',
        },
        reprova: {
            title: 'CONFIRMA REPROVAÇÃO',
            body: 'Deseja reprovar o DFD?',
            confirmText: 'Reprovar',
            confirmClass: 'btn-danger',
            titleClass: 'text-white', // Classe para o título (azul)
            headerClass: 'bg-danger',
        },
        atualizarPrecos: {
            title: 'ATUALIZAR PREÇOS',
            body: 'Deseja buscar os preços na ComprasGov para este item?',
            confirmText: 'Buscar',
            confirmClass: 'btn-warning',
            titleClass: 'text-white',
            headerClass: 'bg-warning',
        },
    };

    // Obtém as propriedades da ação atual ou um objeto vazio se a ação não existir
    const { title, body, confirmText, confirmClass, titleClass, headerClass } = actionMessages[action] || {};

    // Se show for false, não renderiza o modal
    if (!show) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className={`modal-header ${headerClass} py-1`}>
                        {/* Aplica a classe dinâmica ao título */}
                        <h6 className={`modal-title ${titleClass} m-0`}>{title}</h6>
                        <button type="button" className="btn-close btn-close-white shadow-sm p-2" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>{body}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="button" className={`btn ${confirmClass}`} onClick={onConfirm}>
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;